// extracted by mini-css-extract-plugin
export var closeButton = "_m4-1";
export var closeX = "_m4-3";
export var container = "_m4-0";
export var image = "_m4-2";